export default "__VITE_ASSET__C89iD6YN__"